import { render, staticRenderFns } from "./public-notifications.vue?vue&type=template&id=5b3a784d"
import script from "./public-notifications.vue?vue&type=script&lang=js"
export * from "./public-notifications.vue?vue&type=script&lang=js"
import style0 from "./public-notifications.vue?vue&type=style&index=0&id=5b3a784d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports